// The name and email of the second principal invited when a plan is created "together".
//
// Split out of `surfaces/Plans.tsx` so that file never has to name the field: this is the
// one place on the create-plan screen that asks the question, the same way
// `PendingActionRow.tsx` is the one place that asks it when ratifying an invitation — see
// `test/absence.test.tsx`. The parent only ever receives a complete, trimmed
// `TogetherInvite`, or `null` while the pair is incomplete; it never reads either field.

import { useState } from 'react';

import type { TogetherInvite } from '../api/together.js';

export type TogetherInviteFieldsProps = {
  onChange: (invite: TogetherInvite | null) => void;
};

export function TogetherInviteFields({
  onChange,
}: TogetherInviteFieldsProps): JSX.Element {
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');

  const publish = (nextName: string, nextContact: string): void => {
    const trimmedName = nextName.trim();
    const trimmedContact = nextContact.trim();
    onChange(
      trimmedName === '' || trimmedContact === ''
        ? null
        : { name: trimmedName, email: trimmedContact },
    );
  };

  return (
    <div className="newPlan__row">
      <input
        className="newPlan__field"
        value={name}
        placeholder="Their name"
        aria-label="Other principal’s name"
        autoComplete="off"
        onChange={(event) => {
          setName(event.target.value);
          publish(event.target.value, contact);
        }}
      />
      <input
        className="newPlan__field"
        value={contact}
        type="email"
        placeholder="Their email"
        aria-label="Other principal’s email"
        autoComplete="off"
        onChange={(event) => {
          setContact(event.target.value);
          publish(name, event.target.value);
        }}
      />
    </div>
  );
}
